import { StoreState } from "./index";

export function getShareResponse(state: StoreState): StoreState["share"] {
  return state.share;
}

export function getShares(state: StoreState): StoreState["shares"] {
  return state.shares;
}

export function getIsLoadingShares(
  state: StoreState
): StoreState["isLoading"]["shares"] {
  return state.isLoading.shares;
}

export function getIsLoadingShare(
  state: StoreState
): StoreState["isLoading"]["share"] {
  return state.isLoading.share;
}
